<form [formGroup]="profileInfoForm" (ngSubmit)="save()">
    <ng-container *ngIf="userFound">
        <p class="user-found" *ngIf="!allowExistingUser && existingUserIsBuyer && !originalEmail">
            This email address is associated with another account. Please enter a different one.
        </p>
        <p class="user-found" *ngIf="allowExistingUser && activeUserType !== 3 && existingUserIsBuyer && !userOffLimits && !originalEmail">
            Customer found! Is this the right person? If not, please verify and re-enter the email address. If it is the right person but some of their
            information needs to be updated, the customer can do that through the profile screen when they log in.
        </p>
        <p class="user-found" *ngIf="allowExistingUser && activeUserType === 3 && existingUserIsBuyer && !originalEmail">
            This email address is associated with another account. Please enter a different one.
        </p>
        <p class="user-found" *ngIf="allowExistingUser && userOffLimits">
            This email address is associated to another account that cannot be used here. please enter a different one.
        </p>
        <p *ngIf="!existingUserIsBuyer && !originalEmail" class="user-found">
            The buyer's email address is already being used by a Dealer. Please use a different email address.
        </p>
    </ng-container>

    <div class="row">
        <mat-form-field class="col" appearance="fill">
            <mat-label>Email*</mat-label>
            <mat-placeholder>Email</mat-placeholder>
            <input class="form-control" matInput formControlName="email" data-test="profile-info-email" />
            <mat-error>Invalid Email Address</mat-error>
        </mat-form-field>

        <mat-form-field class="col" appearance="fill">
            <mat-label>Mobile Phone*</mat-label>
            <input
                class="form-control"
                type="text"
                matInput
                appPhoneMask
                formControlName="phone"
                id="phone-number"
                placeholder="(XXX) XXX-XXXX"
                maxlength="14"
            />
            <mat-error>Invalid Phone Number</mat-error>
        </mat-form-field>
    </div>
    <div class="row">
        <mat-form-field class="col" appearance="fill">
            <mat-label>First Name*</mat-label>
            <mat-placeholder>First Name</mat-placeholder>
            <input class="form-control" type="text" matInput formControlName="firstName" />
            <mat-error>Invalid First Name</mat-error>
        </mat-form-field>

        <mat-form-field class="col" appearance="fill">
            <mat-label>Middle Initial</mat-label>
            <mat-placeholder>Middle Initial</mat-placeholder>
            <input class="form-control" type="text" matInput formControlName="middleName" required="false" />
            <mat-error>Invalid Middle Initial</mat-error>
        </mat-form-field>

        <mat-form-field class="col" appearance="fill">
            <mat-label>Last Name*</mat-label>
            <mat-placeholder>Last Name</mat-placeholder>
            <input class="form-control" type="text" matInput formControlName="lastName" />
            <mat-error>Invalid Last Name</mat-error>
        </mat-form-field>
    </div>

    <ng-container *ngIf="!disableForm">
        <div class="buttons">
            <button mat-button (click)="closeModal()" type="button" class="secondary">Cancel</button>
            <button mat-button type="submit" class="primary" [disabled]="disableSave" [class.disabled]="disableSave">Save</button>
        </div>
    </ng-container>
</form>
